import {
    callApiLayTatCaGroup,
    callApiLayDanhSachGroupPaging,
    callApiLayChiTietGroup,
    callApiLayDanhSachVaiTroTheoGroup,
    callApiLayDanhSachQuyenTheoGroup,
    callApiCapNhatGroup,
    callApiThemMoiGroup,
    callApiLayDanhSachUserNotInGroup,
    callApiCapNhatQuyenTrongGroup,
    callApiAddMapping,
    callApiRemoveMapping,
    callApiXoaGroup
} from "@/api/group"

import { showMsgError } from "@/utils/commonUtils";
import ENDPOINT from "@/api/endpoints";

const danhSachGroup = async ({ commit }, payload) => {
    const response = await callApiLayTatCaGroup(payload);
    if (response && response.data.succeeded) {
        commit("DANH_SACH_GROUP", response.data.data);
    }
};

const danhSachGroupPaging = async ({ commit }, payload) => {
    const response = await callApiLayDanhSachGroupPaging(payload);
    if (response && response.data.succeeded) {
        commit("DANH_SACH_GROUP_PAGING", response.data.data);
    }
};


const layChiTietGroup = async ({ commit }, payload) => {
    const response = await callApiLayChiTietGroup(payload);
    if (response && response.data.succeeded) {
        commit("SET_CHI_TIET_GROUP", response.data.data);
    }
};


const layDanhSachVaiTroTheoGroup = async ({ commit }, payload) => {
    const response = await callApiLayDanhSachVaiTroTheoGroup(payload);
    if (response && response.data.succeeded) {
        commit("SET_DANH_SACH_VAI_TRO_THEO_GROUP", response.data.data);
    }
};

const layDanhSachQuyenTheoGroup = async ({ commit }, payload) => {
    const response = await callApiLayDanhSachQuyenTheoGroup(payload);
    if (response && response.data.succeeded) {
        commit("SET_DANH_SACH_QUYEN_THEO_GROUP", response.data.data);
    }
};

const layDanhSachUserNotInGroup = async ({ commit }, payload) => {
    const response = await callApiLayDanhSachUserNotInGroup(payload);
    if (response && response.data.succeeded) {
        commit("SET_DANH_SACH_USER_NOT_INGROUP", response.data.data);
    }
};


const themMoiGroup = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiThemMoiGroup(
            payload,
            ENDPOINT.GROUP.ADD
        )
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error.response);
            });
    });
};

const capNhatGroup = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiCapNhatGroup(
            payload,
            ENDPOINT.GROUP.UPDATE
        )
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error.response);
            });
    });
};

const capNhatQuyenTrongGroup = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiCapNhatQuyenTrongGroup(payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                showMsgError(error.response.data.message);
                reject(error);
            });
    });
};

const addMapping = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiAddMapping(payload)
            .then((response) => {
                resolve(response);
            })
            .catch(error => {
                showMsgError(error.response.data.message);
                reject(error);
            });
    });
};

const removeMapping = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiRemoveMapping(payload)
            .then((response) => {
                resolve(response);
            })
            .catch(error => {
                showMsgError(error.response.data.message);
                reject(error);
            });
    });
};

const xoaGroup = (context, payload) => {
    return new Promise((resolve, reject) => {
        callApiXoaGroup(payload)
            .then((response) => {
                resolve(response);
            })
            .catch(error => {
                showMsgError(error.response.data.message);
                reject(error);
            });
    });
};

export default {
    danhSachGroup,
    danhSachGroupPaging,
    layChiTietGroup,
    layDanhSachVaiTroTheoGroup,
    layDanhSachQuyenTheoGroup,
    layDanhSachUserNotInGroup,
    capNhatGroup,
    themMoiGroup,
    capNhatQuyenTrongGroup,
    addMapping,
    removeMapping,
    xoaGroup
}